// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"3157a356","453":"4de64939","758":"0feba40c"}[chunkId] + ".chunk.js";
};